<script>
export default {
  name: 'BaseInputV2',
  data() {
    return {
      isFocused: false,
    }
  },
  computed: {
    containerClass() {
      const classNames = ['tamara-base-input-v2', 'is-lavender-design']

      if (this.isFocused) {
        classNames.push('is-focused')
      }

      return classNames.join(' ')
    },
  },
  methods: {
    handleBlur(evt) {
      this.isFocused = false

      this.$emit('blur', evt)
    },
    handleFocus(evt) {
      this.isFocused = true

      this.$emit('focus', evt)
    },
  },
}
</script>

<template>
  <el-input
    :class="containerClass"
    v-bind="$attrs"
    v-on="$listeners"
    @blur="handleBlur"
    @focus="handleFocus"
  >
    <template v-slot:prefix>
      <slot name="prefix" />
    </template>
    <template v-slot:suffix>
      <slot name="suffix" />
    </template>

    <template v-slot:prepend>
      <slot name="prepend" />
    </template>
  </el-input>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-base-input-v2 {
  &::v-deep {
    &.is-disabled {
      background-color: var(--tamara-color-background-neutral-low);

      .el-input__inner {
        background-color: var(--tamara-color-background-neutral-low);
      }
    }

    &.el-input {
      display: flex;
      gap: 12px;
      align-items: center;
      height: 46px;
      padding: 8px 12px;
      color: var(--tamara-color-content-high);
      border: 1.5px solid var(--tamara-color-border-low);
      border-radius: 12px;

      @extend .tamara-body-large;

      &.is-focused {
        border: 2px solid var(--tamara-color-brand-700);
      }

      .el-input-group__append,
      .el-input-group__prepend {
        display: flex;
        align-items: center;
        width: auto;
        height: auto;
        padding: 0;
        background-color: transparent;
        border: none;
        border-radius: 0;
      }

      .el-input__inner {
        padding: 0;
        border: none;
      }
    }

    &.el-textarea {
      display: flex;
      gap: 12px;
      align-items: center;
      padding: 8px 12px;
      color: var(--tamara-color-content-high);
      border: 1.5px solid var(--tamara-color-border-low);
      border-radius: 12px;

      @extend .tamara-body-large;

      &.is-focused {
        border: 2px solid var(--tamara-color-brand-700);
      }

      .el-textarea__inner {
        padding: 0;
        border: none;
      }
    }
  }
}
</style>
